<template>
  <b-modal
    ok-title="Einladen"
    cancel-title="Abbrechen"
    size="sm"
    id="modal-useradmin"
    title="Benutzer einladen"
    @ok="selectCurrentUser"
    @hide="
      userToBeInvitedFirstName = '';
      userToBeInvitedLastName = '';
      userToBeInvitedEMail = '';
      showAlertMessage = null;
    "
  >
    <template #modal-footer="{ close, ok }">
      <b-button @click="close()">Abbrechen</b-button>
      <b-overlay :show="inviteRequestPending" variant="primary" opacity="1" spinner-small spinner-variant="white">
        <b-button @click="inviteUser(ok)" variant="primary">Einladen</b-button>
      </b-overlay>
    </template>
    <b-overlay :show="inviteRequestPending" variant="white" opacity="1" spinner-variant="primary">
      <!--
      <div class="container mb-4">
        <div class="row">
          <div class="col p-0" style="width: 30%">
            <h6>Verfügbare Benutzer</h6>
            <div class="border">
              <b-table
                sort-by="Name"
                ref="usersTable"
                id="usersTable"
                @row-clicked="(item, index) => onRowClicked('usersTable', item, index)"
                selectable
                no-select-on-click
                select-mode="single"
                :items="users"
                :fields="selectDialogFields"
                responsive=""
                thead-class="d-none"
                class="selection-table mb-0"
              >
                <template #cell(Name)="data">
                  <b-icon icon="person" class="mr-2" />
                  {{ data.item.Name }}
                </template>
              </b-table>
            </div>
          </div>
          <div class="col-auto align-self-center">
            <center>
              <div class="row mb-1">
                <div class="col">
                  <b-button block @click="makeReader"><b-icon icon="chevron-right" /></b-button>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <b-button block @click="makeUser"><b-icon icon="chevron-left" /></b-button>
                </div>
              </div>
            </center>
          </div>
          <div class="col p-0" style="width: 30%">
            <h6>Leser</h6>
            <div class="border">
              <b-table
                ref="readersTable"
                id="readersTable"
                @row-clicked="(item, index) => onRowClicked('readersTable', item, index)"
                selectable
                select-mode="single"
                no-select-on-click
                :items="usersReader"
                :fields="selectDialogFields"
                responsive=""
                thead-class="d-none"
                class="selection-table mb-0"
              >
                <template #cell(Name)="data">
                  <b-icon icon="person" class="mr-2" />
                  {{ data.item.Name }}
                </template>
              </b-table>
            </div>
          </div>
          <div class="col-auto align-self-center">
            <center>
              <div class="row mb-1">
                <div class="col">
                  <b-button block @click="makeLead"><b-icon icon="chevron-right" /></b-button>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <b-button block @click="makeReader"><b-icon icon="chevron-left" /></b-button>
                </div>
              </div>
            </center>
          </div>
          <div class="col p-0" style="width: 30%">
            <h6>Projektleiter</h6>
            <div class="border">
              <b-table
                ref="leadsTable"
                id="leadsTable"
                @row-clicked="(item, index) => onRowClicked('leadsTable', item, index)"
                selectable
                no-select-on-click
                select-mode="single"
                :items="usersLead"
                :fields="selectDialogFields"
                responsive=""
                thead-class="d-none"
                class="selection-table mb-0"
              >
                <template #cell(Name)="data">
                  <b-icon icon="person" class="mr-2" />
                  {{ data.item.Name }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>-->
      <!--
      <div id="table-user-selection-wrapper" class="border">
        <b-table
          id="table-user-selection"
          thead-class="d-none"
          selectable
          select-mode="single"
          hover
          fixed
          :items="users"
          :fields="fields"
          @row-selected="onRowSelected"
        >
          <template #cell(icon)="data"><b-icon :icon="data.item.icon" /></template>
          <template #cell(actions)="data">
            <b-icon icon="trash" title="Benutzer aus dem Projekt entfernen" @click.stop="deleteUser(data.item)" />
          </template>
        </b-table>
      </div>-->

      <b-form ref="inviteUserForm" id="inviteUserForm" autocomplete="off">
        <div class="row mb-2">
          <div class="col">
            <label class="mb-0"><small class="text-muted">Vorname</small></label>
            <b-input
              v-model="userToBeInvitedFirstName"
              placeholder="Vorname"
              required
              autofocus
              @input="showAlertMessage = null"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <label class="mb-0"><small class="text-muted">Nachname</small></label>
            <b-input
              v-model="userToBeInvitedLastName"
              placeholder="Nachname"
              required
              @input="showAlertMessage = null"
            />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <label class="mb-0"><small class="text-muted">E-Mail Adresse</small></label>
            <b-input
              v-model="userToBeInvitedEMail"
              :state="showEmailValidationError && showEmailValidationError !== null ? false : null"
              placeholder="E-Mail"
              type="email"
              required
              @input="showEmailValidationError = null"
            />
            <b-form-invalid-feedback class="d-block" style="height: 20px" id="input-live-feedback">
              {{ showEmailValidationError }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <!--
      <b-overlay :show="inviteRequestPending" variant="secondary" opacity="1" spinner-small spinner-variant="white">
        <b-button block @click="inviteUser"><b-icon icon="check-2" scale="1.5" /></b-button>
      </b-overlay>-->
      </b-form>
    </b-overlay>

    <b-alert variant="danger" dismissible :show="showAlertMessage != null" fade>
      {{ showAlertMessage }}
    </b-alert>
    <b-alert variant="success" dismissible fade :show="showInfoSeconds" @dismissed="showInfoSeconds = 0">
      {{ showInfoMessage }}
    </b-alert>
  </b-modal>
</template>

<script>
import ProjectService from '@/service/ProjectsService';
import ProjectStore from '@/store/Projects';
export default {
  props: {
    selectedUser: {
      type: String
    },
    selectedUserId: {
      type: String
    }
  },
  data() {
    return {
      users: [],
      usersReader: [],
      usersLead: [],
      selectedUserObject: null,
      inviteRequestPending: false,
      tableActionPending: false,
      userToBeInvitedEMail: '',
      userToBeInvitedLastName: '',
      userToBeInvitedFirstName: '',
      showAlertMessage: null,
      showEmailValidationError: null,
      showInfoMessage: null,
      showInfoSeconds: 0,
      selectDialogFields: [
        {
          key: 'Name',
          label: 'Benutzername',
          sortable: true,
          tdClass: ''
        }
      ],
      fields: [
        {
          key: 'Icon',
          label: '',
          thClass: 'icon-cell',
          tdClass: 'icon-cell'
        },
        {
          key: 'Name',
          label: 'Benutzername',
          sortable: true,
          tdClass: 'pl-0'
        },
        {
          key: 'Actions',
          label: '',
          thClass: 'actions-cell',
          tdClass: 'actions-cell'
        }
      ],
      currentSelectedUser: null,
      currentSelectedUserId: null
    };
  },
  methods: {
    onRowClicked(table, item, index) {
      switch (table) {
        case 'usersTable':
          this.$refs.readersTable.clearSelected();
          this.$refs.leadsTable.clearSelected();
          this.$refs.usersTable.selectRow(index);
          break;
        case 'readersTable':
          this.$refs.usersTable.clearSelected();
          this.$refs.leadsTable.clearSelected();
          this.$refs.readersTable.selectRow(index);
          break;
        case 'leadsTable':
          this.$refs.usersTable.clearSelected();
          this.$refs.readersTable.clearSelected();
          this.$refs.leadsTable.selectRow(index);
          break;
      }
      this.selectedUserObject = item;
    },
    /*
    onUserRowSelected(table, selectedItems) {
      switch (table) {
        case 'usersTable':
          this.$refs.readersTable.clearSelected();
          this.$refs.leadsTable.clearSelected();
          break;
        case 'readersTable':
          this.$refs.usersTable.clearSelected();
          this.$refs.leadsTable.clearSelected();
          break;
      }
    },
    selectCurrentUserObject() {
      this.$refs.usersTable.clearSelected();
      this.$refs.readersTable.clearSelected();
      this.$refs.leadsTable.clearSelected();
      const that = this;
      const userObj = this.selectedUserObject;
      this.$nextTick(() => {
        if (this.users.find(x => x.UserId == userObj.UserId)) {
          this.$refs.usersTable.selectRow(that.users.indexOf(userObj));
        }
        if (this.usersReader.find(x => x.UserId == userObj.UserId)) {
          this.$refs.readersTable.selectRow(that.usersReader.indexOf(userObj));
        }
        if (this.usersLead.find(x => x.UserId == userObj.UserId)) {
          this.$refs.leadsTable.selectRow(that.usersLead.indexOf(userObj));
        }
      });
    },*/
    makeUser() {
      this.$refs.usersTable.clearSelected();
      this.$refs.readersTable.clearSelected();
      this.$refs.leadsTable.clearSelected();

      this.$utils.deleteItemFromArray(this.usersReader, x => x.UserId == this.selectedUserObject.UserId);
      this.$utils.deleteItemFromArray(this.usersLead, x => x.UserId == this.selectedUserObject.UserId);

      this.users.push(this.selectedUserObject);
      this.users.sort((a, b) => {
        if (a.Name < b.Name) {
          return -1;
        }
        if (a.Name > b.Name) {
          return 1;
        }
        return 0;
      });

      this.$nextTick(() => {
        const idx = this.$refs.usersTable.items.map(x => x.UserId).indexOf(this.selectedUserObject.UserId);
        this.$refs.usersTable.selectRow(idx);
      });
    },
    makeReader() {
      if (this.usersReader.indexOf(this.selectedUserObject) > -1) return;
      this.$refs.usersTable.clearSelected();
      this.$refs.readersTable.clearSelected();
      this.$refs.leadsTable.clearSelected();
      this.$utils.deleteItemFromArray(this.users, x => x.UserId == this.selectedUserObject.UserId);
      this.$utils.deleteItemFromArray(this.usersLead, x => x.UserId == this.selectedUserObject.UserId);

      this.usersReader.push(this.selectedUserObject);
      this.$utils.sortArray(this.usersReader, 'Name');

      this.$nextTick(() => {
        const idx = this.$refs.readersTable.items.indexOf(this.selectedUserObject);
        this.$refs.readersTable.selectRow(idx);
      });
    },
    makeLead() {
      if (this.usersLead.indexOf(this.selectedUserObject) > -1) return;
      this.$refs.usersTable.clearSelected();
      this.$refs.readersTable.clearSelected();
      this.$refs.leadsTable.clearSelected();
      this.$utils.deleteItemFromArray(this.usersReader, x => x.UserId == this.selectedUserObject.UserId);

      this.usersLead.push(this.selectedUserObject);
      this.usersLead.sort((a, b) => {
        if (a.Name < b.Name) {
          return -1;
        }
        if (a.Name > b.Name) {
          return 1;
        }
        return 0;
      });
      this.$nextTick(() => {
        const idx = this.$refs.leadsTable.items.map(x => x.UserId).indexOf(this.selectedUserObject.UserId);
        this.$refs.leadsTable.selectRow(idx);
      });
    },
    /*
    onUserSelected(a) {
      //const that = this;
      if (this.usersReader.length > 0) {
        //this.usersReader
        //.filter(x => x.UserId == this.selectedUserObject.UserId)
        //.forEach(x => {
        for (const idx in this.$refs.readersTable.selectedRows) {
          if ((idx, this.$refs.readersTable.selectedRows[idx] == true)) {
            this.$refs.readersTable.unselectRow(parseFloat(idx));
          }
        }
      }
      this.selectedUserObject = a[0];
      //});
    },
    onReaderSelected(a) {
      if (this.users.length > 0) {
        //this.usersReader
        //.filter(x => x.UserId == this.selectedUserObject.UserId)
        //.forEach(x => {
        for (const idx in this.$refs.usersTable.selectedRows) {
          if ((idx, this.$refs.usersTable.selectedRows[idx] == true)) {
            this.$refs.usersTable.unselectRow(parseFloat(idx));
          }
        }
      }
      //console.log("reader selected", a)
      //        for (var x in this.$refs.usersTable.selectedRows) {
      //this.$refs.usersTable.unselectRow(parseInt(x));
      //}
      //this.$nextTick(() => {
      this.selectedUserObject = a[0];
      //});
    },
    onLeadSelected(a) {
      //console.log("bam lead")
      this.$refs.readersTable.clearSelected();
      this.$refs.usersTable.clearSelected();
      //
      //    this.$nextTick(() => {
      this.selectedUserObject = a[0];
      //});
    },*/
    selectCurrentUser() {
      if (this.currentSelectedUser) {
        this.$emit('update:selectedUser', this.currentSelectedUser);
        this.$emit('update:selectedUserId', this.currentSelectedUserId);
      }
    },
    /*
    loadData() {
      ProjectService.getUsersByProject().then(users => {
        this.users = users;
      });
    },*/
    inviteUser(okFn) {
      if (!this.$refs.inviteUserForm.checkValidity()) {
        return this.$refs.inviteUserForm.reportValidity();
      }
      this.inviteRequestPending = true;
      this.tableActionPending = true;
      this.showAlertMessage = null;
      ProjectService.inviteUser(
        this.userToBeInvitedFirstName,
        this.userToBeInvitedLastName,
        this.userToBeInvitedEMail,
        ProjectStore.activeProject.Name
      )
        .then(response => {
          this.inviteRequestPending = false;
          this.tableActionPending = false;
          this.userToBeInvitedFirstName = '';
          this.userToBeInvitedLastName = '';
          this.userToBeInvitedEMail = '';

          this.$emit('ok');
          okFn();
          if (response > 200 && response <= 210) {
            this.$showSuccess(
              this,
              'Benutzer einladen',
              'Der Benutzer wurde dem Projekt hinzugefügt. Bitte vergeben Sie dem Benutzer ggf. eine höhere Rolle.'
            );
            //this.showInfoMessage =
            //              'Der Benutzer wurde dem Projekt hinzugefügt. Bitte vergeben Sie dem Benutzer ggf. eine höhere Rolle.';
            //this.showInfoSeconds = 3;
            /*
            this.$bvModal
              .msgBoxOk(
                'Der Benutzer wurde dem Projekt hinzugefügt. Bitte vergeben Sie dem Benutzer ggf. eine höhere Rolle.',
                {
                  title: 'Benutzer einladen',
                  //okVariant: 'danger',
                  //headerTextVariant: 'danger',
                  centered: true
                }
              )
              .finally(() => {
                this.userToBeInvited = '';
                this.userToBeInvitedFirstName = '';
                this.userToBeInvitedLastName = '';
                this.userToBeInvitedEMail = '';
              });*/
          } else if (response > 210) {
            this.$showSuccess(this, 'Benutzer einladen', 'Der Benutzer wurde diesem Projekt hinzugefügt.');
            //this.showInfoMessage = 'Der Benutzer wurde diesem Projekt hinzugefügt.';
            //this.showInfoSeconds = 3;
            /*
            this.$bvModal
              .msgBoxOk('Der Benutzer existiert bereits in diesem Projekt.', {
                title: 'Benutzer einladen',
                //okVariant: 'danger',
                //headerTextVariant: 'danger',
                centered: true
              })
              .finally(() => {
                this.userToBeInvited = '';
                this.userToBeInvitedFirstName = '';
                this.userToBeInvitedLastName = '';
                this.userToBeInvitedEMail = '';
                this.inviteRequestPending = false;
              });*/
          } else {
            this.$showSuccess(
              this,
              'Benutzer einladen',
              'Eine E-Mail mit einem Einladungslink wurde an den Benutzer versendet. Bitte vergeben Sie dem Benutzer ggf. eine höhere Rolle.'
            );
            //this.showInfoMessage =
            //'Eine E-Mail mit einem Einladungslink wurde an den Benutzer versendet.<br><br>Bitte vergeben Sie dem Benutzer ggf. eine höhere Rolle.';
            //          this.showInfoSeconds = 3;
            /*
            const messageVNode = this.$createElement('div', {
              domProps: {
                innerHTML: `Eine E-Mail mit einem Einladungslink wurde an den Benutzer versendet.<br><br>Bitte vergeben Sie dem Benutzer ggf. eine höhere Rolle.`
              }
            });
            this.$bvModal
              .msgBoxOk([messageVNode], {
                title: 'Benutzer einladen',
                //okVariant: 'danger',
                //headerTextVariant: 'danger',
                centered: true
              })
              .finally(() => {
                this.userToBeInvited = '';
                this.userToBeInvitedFirstName = '';
                this.userToBeInvitedLastName = '';
                this.userToBeInvitedEMail = '';
                this.inviteRequestPending = false;
              });*/
          }
        })
        .catch(err => {
          if (err.response && err.response.status == 409) {
            this.showEmailValidationError = err.response.data;
            //this.$showError(this, 'Benutzer einladen', 'Benutzer existiert bereits!');
            //this.showAlertMessage = 'Benutzer existiert bereits!';
            //this.showAlertSeconds = 3;
          } else if (err.response && err.response.status == 503) {
            this.showEmailValidationError = err.response.data;
          } else {
            this.showAlertMessage = err.response.data;
            //this.$showError(this, err.toString());
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            //okFn();
            //this.loadData();
            this.inviteRequestPending = false;
            this.tableActionPending = false;
          });
        });
    },
    deleteUser(item) {
      this.$bvModal
        .msgBoxConfirm('Soll der Benutzer "' + item.text + '" wirklich aus dem Projekt entfernt werden?', {
          title: 'Benutzer löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.tableActionPending = true;
            ProjectService.deleteProjectUser(item.UserId)
              .then(() => {
                this.$utils.deleteItemFromArray(this.users, x => x.DbId == item.DbId);
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              })
              .finally(() => (this.tableActionPending = false));
          }
        });
    },
    onRowSelected(row) {
      if (row && row.length > 0) {
        this.currentSelectedUser = row[0].text;
        this.currentSelectedUserId = row[0].DbId;
      }
    }
  }
};
</script>

<style>
.modal-xl {
  width: 1200px !important;
}
#table-user-selection-wrapper {
  min-height: 300px;
}
.icon-cell {
  width: 40px !important;
}

.actions-cell {
  width: 50px !important;
}
.col {
  flex: 1 0 0%;
}
.selection-table td {
  border-top: none;
  border-bottom: 1px solid rgb(222, 226, 230);
  background-color: white;
}
.selection-table {
  background-color: #f5f5f5;
  height: 200px;
}
</style>
